<template>
  <Form :model="formItem" ref="formItem" :label-width="150" :rules="formRules">
    <FormItem label="主体信息">
      <Input
        v-model="formItem.businessInfo"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="渠道编码">
      <Input
        v-model="formItem.channelCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="营业执照名称">
      <Input
        v-model="formItem.lecienceName"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="营业执照号">
      <Input
        v-model="formItem.lecienceCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="营业执照图片">
      <Upload
        ref="upload"
        :show-upload-list="false"
        :action="`${baseURL}base/file/publicUpload?scene=SHOP`"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="2048000"
        :headers='{"token": $sessionToken()}'
      >
        <Button icon="ios-cloud-upload-outline" :loading="uploading"
          >上传图片</Button
        >
      </Upload>
      <div v-if="formItem.lecienceImgUrl" class="main-image">
        <img :src="formItem.lecienceImgUrl" alt="" />
        <div class="delete" @click="deleteImage('lecienceImgUrl')"></div>
      </div>
      <!-- <div v-if="formItem.lecienceImgUrl" :style="{ marginTop: '5px' }">
        <Avatar shape="square" size="large" :src="formItem.lecienceImgUrl" />
      </div> -->
      <div class="tip">
        仅支持jpg/png，图片比例为:1:1， 建议尺寸：180*180，不超过2M
      </div>
    </FormItem>
    <FormItem label="资金商等级">
      <Select v-model="formItem.dealerLevel" style="width: 60%">
        <Option v-for="item in (spGroupList.data || [])" :key="item.code" :value="item.code">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="资金商名称">
      <Input
        v-model="formItem.name"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="父级资金商">
      <Input
        v-model="formItem.parentCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="联系人">
      <Input
        v-model="formItem.contacTperson"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="电话" prop="contactMobile">
      <Input
        v-model="formItem.contactMobile"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="省市级">
      <Select
        v-model="province"
        style="width: 200px"
        @on-change="(code) => selectArea('province', code)"
      >
        <Option
          v-for="(item, index) in provinceList"
          :key="item.areaCode + '_' + index"
          :value="item.code + '||' + item.areaName"
          >{{ item.areaName }}</Option
        >
      </Select>
      <Select
        v-model="city"
        style="width: 200px"
        @on-change="(code) => selectArea('city', code)"
      >
        <Option
          v-for="(item, index) in cityList"
          :key="item.areaCode + '_' + index"
          :value="item.code + '||' + item.areaName"
          >{{ item.areaName }}</Option
        >
      </Select>
      <!-- <Select
        v-model="county"
        style="width: 200px"
        @on-change="(code) => selectArea('county', code)"
      >
        <Option
          v-for="(item, index) in countyList"
          :key="item.areaCode + '_' + index"
          :value="item.code + '||' + item.areaName"
          >{{ item.areaName }}</Option
        >
      </Select> -->
    </FormItem>
    <FormItem label="详细地址">
      <Input
        v-model="formItem.addr"
        type="textarea"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="达能经销商编码">
      <Input
        v-model="formItem.elnDealerCode"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="达能经销商名称">
      <Input
        v-model="formItem.elnDealerName"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem label="状态">
          <RadioGroup v-model="formItem.status">
            <Radio label="0">正常</Radio>
            <Radio label="1">停用</Radio>
        </RadioGroup>
    </FormItem>
    <FormItem label="备注">
      <Input
        v-model="formItem.remark"
        type="textarea"
        placeholder="请输入"
        style="width: 60%"
      ></Input>
    </FormItem>
    <FormItem>
      <Button type="primary" @click="add">{{
        mode === "edit" ? "修改" : "添加"
      }}</Button>
      <Button style="margin-left: 8px" @click="back">取消</Button>
    </FormItem>
  </Form>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
  data() {
    return {
      mode: "add",
      formItem: {
        addr: "",
        businessInfo: "",
        channelCode: "",
        cityId: "",
        cityName: "",
        contacTperson: "",
        contactMobile: "",
        dealerLevel: "",
        elnDealerCode: "",
        elnDealerName: "",
        groupCode: "000",
        lecienceCode: "",
        lecienceImgUrl: "",
        lecienceName: "",
        name: "",
        parentCode: "",
        provinceId: "",
        provinceName: [],
        remark: "",
        stype: "0",
        status: ""
      },
      formRules: {
        contactMobile: [{
          // required: true, 
          type: 'string',
          pattern: /^1[3456789]\d{9}$/,
          message: '请输入正确的电话格式',
          trigger: 'blur'
        }]
      },
      provinceList: [],
      province: "",
      cityList: [],
      city: "",
      countyList: [],
      county: "",
      uploading: false,
      baseURL: "",
    };
  },
  computed: {
    ...mapGetters({
      shopInfo: "merchant/getShopInfoQuery",
      spGroupList: "spGroup/getSpGroupList",
    }),
  },
  watch: {
    shopInfo: {
      deep: true,
      handler: function (newv, oldv) {
        if (newv) {
          
          // 处理省市
          this.province = `${newv.provinceId}||${newv.provinceName}`;
          if(this.province){
            this.city = `${newv.cityId}||${newv.cityName}`;
            this.selectArea("province", this.province)
          }

          this.formItem = Object.assign(newv);
        }
      },
    },
  },
  created() {
    this.baseURL = axios.defaults.baseURL;
    // 区分模式
    console.log(this.$route.query.code);
    // 编辑模式
    if (this.$route.query.code) {
      this.mode = "edit";
      this.getDetail();
    } else {
      this.mode = "add";
    }

    this.getArea("provinceList");

    // 获取资金商分组
    this.$store.dispatch("spGroup/getSpGroupList", { pageSize: 100 }).then(() => {
      console.log(this.spGroupList)
    });
  },
  methods: {
    getDetail() {
      this.$store
        .dispatch("merchant/shopInfoQuery", {
          code: this.$route.query.code,
        })
        .then(() => {})
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    changeStype(value) {
      if (value == 0) {
        this.formItem.groupCode = "000";
      } else {
        this.formItem.groupCode = "";
      }
    },
    selectArea(type, value) {
      const kv = value.split("||");
      if (type === "province") {
        this.getArea("cityList", kv[0], kv[1]);
      } else if (type === "city") {
        console.log(this.province, this.city, this.county);
        const p_kv = this.province.split("||");
        const c_kv = this.city.split("||");

        this.formItem.provinceId = p_kv[0];
        this.formItem.provinceName = p_kv[1];
        this.formItem.cityId = c_kv[0];
        this.formItem.cityName = c_kv[1];
        // this.getArea("countyList", kv[0], kv[1]);
      } else if (type === "county") {
        // console.log(this.province, this.city, this.county);
        // const p_kv = this.province.split("||");
        // const c_kv = this.city.split("||");

        // this.formItem.provinceId = p_kv[0];
        // this.formItem.provinceName = p_kv[1];
        // this.formItem.cityId = c_kv[0];
        // this.formItem.cityName = c_kv[1];
      }
    },
    getArea(target, code = "", label = "") {
      this.$http({
        url: axios.defaults.baseURL + "base/area/query",
        method: "GET",
        params: { code },
      })
        .then((res) => res.data)
        .then((data) => {
          if (data.code == 200) {
            this.$set(this, target, data.data);
          } else {
            console.log(data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    beforeUpload(d) {
      // let size = d.size;
      // let type = d.type;
      // if (size > 2048000) {
      //   this.$Message.error("图片不可大于2M");
      //   return false; //停止上传
      // }
      // if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
      //   this.$Message.error("仅支持jpg/png");
      //   return false; //停止上传
      // }
      this.uploading = true;
    },
    uploadSuccess(response, file, fileList) {
      this.uploading = false;
      if (response.code == 200) {
        this.formItem.lecienceImgUrl = response.data.url;
      } else {
        this.$Message.error(response.message || "上传失败");
      }
    },
    deleteImage(target) {
      this.formItem.lecienceImgUrl = "";
    },
    uploadError() {
      this.formItem.lecienceImgUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    // 添加
    add() {
      console.log(this.formItem, "formItem");
      this.$refs["formItem"].validate(valid => {
        if(valid){
          this.$Spin.show();

          this.$store
            .dispatch(
              this.mode == "edit"
                ? "merchant/shopInfoUpdate"
                : "merchant/shopInfoAdd",
              this.formItem
            )
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success("添加成功");
                setTimeout(this.back, 3000);
              } else {
                this.$Message.error(res.message || "添加失败，请稍后重试！");
              }
            })
            .catch((err) => {
              console.error(err);
              this.$Message.error(err);
            })
            .finally(this.$Spin.hide);
        }
      })
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style>
.ivu-input {
  width: 100%;
}

.main-image {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #dcdfe6;
  margin-right: 20px;
  margin-top: 10px;
  overflow: hidden;
}
.main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.main-image .delete {
  display: none;
  position: absolute;
  height: 20px;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.main-image .delete::after {
  content: " ";

  display: inline-block;
  height: 20px;
  width: 14px;
  background-image: url(data:image/png;base64,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);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.main-image:hover .delete {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/views/merchant/manage/create.vue